/**
 * Formats an ISO timestamp the way the live blog renders dates ("May 29, 2026")
 * — used by the post byline and the Press feed's announcement cards.
 *
 * en-US is correct unconditionally: the blog is default-locale-only. Formatting
 * in UTC keeps the output a pure function of the stored timestamp (not the
 * ambient clock or server TZ), satisfying `invariants.md#ssr-safe-rendered-dates`.
 */
export function formatPublishDate(iso: string): string {
    return new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        timeZone: 'UTC',
    }).format(new Date(iso))
}

/**
 * The compact form used in tabular listings ("May 29, 2026" → "May 29, 2026"
 * with a short month). UTC for the same reason as {@link formatPublishDate}:
 * the output stays a pure function of the stored timestamp
 * (`invariants.md#ssr-safe-rendered-dates`).
 */
export function formatCompactPublishDate(iso: string): string {
    return new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        timeZone: 'UTC',
    }).format(new Date(iso))
}
